import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Hero from "./components/Hero";
import FormPortal from "./pages/FormPortal";
import FormDetail from "./pages/FormDetail";
import "./App.css";

function App() {
  return (
    <Router>
      <div className="app">
        <Routes>
          <Route path="/" element={<Hero />} />
          <Route path="/test/forms" element={<FormPortal />} />
          <Route path="/test/forms/:formId" element={<FormDetail />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
